import type React from 'react';

export type ContainerComponent = React.FC<React.PropsWithChildren<unknown>>;

export enum SortDirection {
    ASC = 'asc',
    DESC = 'desc',
}
